import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { DateTime } from "luxon";
import { calcPosition } from "../../../../utils/TijdlijnDateCalcUtils";
import styles from "./Dienstblok.module.css";

interface IDienstblok {
  dienstTijd: DateTime | null;
  isBeginTijd?: boolean;
  scale: number;
}

export function Dienstblok({ dienstTijd, isBeginTijd = false, scale }: Readonly<IDienstblok>) {
  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;

  if (dienstTijd === null || dienstTijd > timeLineEnd || dienstTijd < timeLineBegin) {
    return;
  }

  const left = calcPosition(dienstTijd, timeLineBegin, timeLineEnd, scale);

  return (
    <div
      style={{
        left: left - (isBeginTijd ? 7 : 18),
      }}
      className={
        styles["dienstblok"] +
        " ".concat(isBeginTijd ? styles["dienstblok-starttijd"] : styles["dienstblok-eindtijd"])
      }
    >
      <div
        className={
          styles["dienstblok-inner"] +
          " ".concat(isBeginTijd ? styles["dienstblok-starttijd"] : styles["dienstblok-eindtijd"])
        }
      />
    </div>
  );
}
